var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ketcher',{ref:"editor",attrs:{"options":_vm.options,"dataId":_vm.dataId,"propValue":_vm.propValue,"validateArg":_vm.validateArg},on:{"change":_vm.changeHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }